import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import { Typography } from "@mui/material";
import { getCookie } from "../hooks/jwtCookie";

interface BankBalanceInterface {
    name: string;
    balance: string | number;
    payments: string | number;
}

const WelcomePage = () => {
    const [bankBalances, setBankBalances] = useState<BankBalanceInterface[]>([]);
    useEffect(() => {
        const loadRealTimeBalances = async () => {
            const jwtToken = getCookie('jwtToken');
            const response = await fetch('/api/dashboard/realtime-payments', {
                headers: {
                    'Authorization': `Bearer ${jwtToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data: BankBalanceInterface[] = await response.json();

                setBankBalances(data);
            } else {
                console.error('Failed to fetch records');
            }
        };

        loadRealTimeBalances();
    }, []);

    const formatAmount = (amount: string | number): string => {
        if (!amount) return '0.00';

        if (typeof amount === 'number') {
            amount = amount.toString();
        }

        amount = amount.replace(',', '.');
        const parts = amount.split('.');
        const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // Форматирование разделителей тысяч
        const decimalPart = parts[1] ? parts[1].padEnd(2, '0') : '00'; // Всегда два знака после точки
        return `${integerPart}.${decimalPart}`;
    };

    return (
        <Box
            sx={{
                p: 2,
                py: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                textAlign: 'left',
            }}
        >
            <Card variant="outlined" sx={{ maxWidth: 360 }}>
                <Box sx={{ p: 0 }}>

                    <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 14, p: 2 }}>
                        Балансы на текущий день
                    </Typography>
                    <TableContainer component={Paper}>
                        <Table aria-label="table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Банк</TableCell>
                                    <TableCell>Баланс</TableCell>
                                    <TableCell>Отправлено</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {bankBalances.map((balance, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{balance.name}</TableCell>
                                        <TableCell>{formatAmount(balance.balance)}</TableCell>
                                        <TableCell>{formatAmount(balance.payments)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Card>

        </Box>
    );
};

export default WelcomePage;
